import Header from "components/ui/Header2";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedProducts from "./components/FeaturedProducts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DiscountedProducts from "./components/DiscountedProducts";
import Footer from "components/common/Footer";
import HomeBanners from "./components/HomeBanners";

export default function Home() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className="bg-background" dir="rtl">
      <Header />
      {/* ================= HERO ================= */}
      <section
        className="pt-28 pb-20 bg-[linear-gradient(135deg,#003459_0%,#005173_100%)]
 text-white"
      >
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row-reverse items-center justify-between gap-12">
            {/* ===== Image Side ===== */}
            <div className="flex-1 flex justify-center">
              <img
                src="/assets/images/hero-herbs.png"
                alt="hero"
                className="max-w-md w-full object-contain drop-shadow-2xl"
              />
            </div>

            {/* ===== Text Side ===== */}
            <div className="flex-1 text-right space-y-6">
              <h1 className="text-4xl lg:text-5xl font-bold leading-tight">
                {t("hero_title_line1")}
                <span className="text-accent block mt-2">
                  {t("hero_title_line2")}
                </span>
              </h1>

              <p className="text-lg text-white/90 max-w-xl">
                {t("hero_description")}
              </p>

              <div className="flex gap-4 justify-start lg:justify-start">
                <button
                  onClick={() => navigate("/product-listing")}
                  className="bg-accent px-6 py-3 rounded-lg font-semibold shadow-lg hover:opacity-90 transition"
                >
                  {t("shop_now")}
                </button>

                <button className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-[#003459] transition">
                  {t("learn_more")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================= WHY CHOOSE US ================= */}
      <section className="py-16 bg-surface">
        <div className="container text-center space-y-12">
          <h2 className="text-3xl font-bold text-primary">
            {t("why_choose_us")}
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {/* بطاقة 1 */}
            <div className="p-6 bg-card rounded-lg shadow-xl flex items-center gap-6 hover:shadow-2xl transition-shadow flex-row-reverse">
              <img
                src="assets/images/100.jpg"
                alt=""
                className="w-[84px] h-[84px]"
              />
              <div>
                <h3 className="text-lg font-semibold text-primary">
                  {t("organic")}
                </h3>
                <p className="text-text-secondary mt-2">{t("organic_desc")}</p>
              </div>
            </div>

            {/* بطاقة 2 */}
            <div className="p-6 bg-card rounded-lg shadow-xl flex items-center gap-6 hover:shadow-2xl transition-shadow flex-row-reverse">
              <img
                src="assets/images/reciclaje.png"
                alt=""
                className="w-[84px] h-[84px]"
              />
              <div>
                <h3 className="text-lg font-semibold text-primary">
                  {t("lab_tested")}
                </h3>
                <p className="text-text-secondary mt-2">
                  {t("lab_tested_desc")}
                </p>
              </div>
            </div>

            {/* بطاقة 3 */}
            <div className="p-6 bg-card rounded-lg shadow-xl flex items-center gap-6 hover:shadow-2xl transition-shadow flex-row-reverse">
              <img
                src="assets/images/shipped.png"
                alt=""
                className="w-[84px] h-[84px]"
              />
              <div>
                <h3 className="text-lg font-semibold text-primary">
                  {t("fast_delivery")}
                </h3>
                <p className="text-text-secondary mt-2">
                  {t("fast_delivery_desc")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= HOME BANNERS ================= */}

      <HomeBanners />
      {/* ================= CATEGORIES ================= */}
      <section className="py-20">
        <div className="container space-y-10">
          <h2 className="text-3xl font-bold text-primary text-center">
            {t("shop_by_category")}
          </h2>

          <CategoryGrid />
        </div>
      </section>
      {/* ================= FEATURED PRODUCTS ================= */}
      <section className="py-20 bg-surface">
        <div className="container space-y-10">
          <h2 className="text-3xl font-bold text-primary text-center">
            {t("featured_products")}
          </h2>

          <FeaturedProducts />
        </div>
      </section>

      {/* ================= FEATURED PRODUCTS ================= */}

      <DiscountedProducts />

      {/* ================= PROMO BANNER ================= */}
      <section className="py-16 bg-primary text-white">
        <div className="container text-center space-y-6">
          <h2 className="text-4xl font-bold">{t("promo_title")}</h2>

          <p className="text-lg opacity-90">{t("promo_description")}</p>

          <button
            onClick={() =>
              (window.location.href = "/product-listing?discounted=true")
            }
            className="bg-accent text-white px-8 py-3 rounded-md shadow-interactive hover:opacity-90"
          >
            {t("discover_now")}
          </button>
        </div>
      </section>
      {/* ================= NEWSLETTER ================= 
      <section className="py-20 bg-background">
        <div className="container text-center space-y-6 max-w-2xl">
          <h2 className="text-3xl font-bold text-primary">
            {t("newsletter_title")}
          </h2>

          <p className="text-text-secondary">{t("newsletter_description")}</p>

          <div className="flex flex-col sm:flex-row gap-4 justify-start">
            <input
              type="email"
              placeholder={t("email_placeholder")}
              className="flex-1 px-4 py-3 border border-border text-right rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
            <button className="bg-accent text-white px-6 py-3 rounded-md hover:opacity-90">
              {t("subscribe")}
            </button>
          </div>
        </div>
      </section>*/}

   <Footer />
    </div>
  );
}
